import React        from 'react';
import d3           from 'd3';
import ChartLine  from '../ChartLine/ChartLine.jsx';
import HighlightPoints  from '../HighlightPoints/HighlightPoints.jsx';
import XYAxis       from '../XYAxis/XYAxis.jsx';
import PointsTooltip       from '../PointsTooltip/PointsTooltip.jsx';
import SizeGiver from '../../../containers/SizeGiver/SizeGiver.jsx';
import SVGChart from '../SVGChart/SVGChart.jsx';
import LineChartChart from '../LineChartChart/LineChartChart.jsx';
import HtmlLegend from '../HtmlLegend/HtmlLegend.jsx';
import HtmlTooltip from '../HtmlTooltip/HtmlTooltip.jsx';
import MouseTracker from '../MouseTracker/MouseTracker.jsx';



export default class LineChart extends React.Component {
    constructor(props,context) {
        super(props,context);
        this.state = {
            tooltipdata:null,
            tooltipVisible:false
        }
        this.handleHighlight = this.handleHighlight.bind(this);
    }
    handleHighlight(data) {
        this.setState({
            tooltipdata:data,
            tooltipVisible: data!=null    
        })
    }
    getTooltipTitle(xval) {
        let retval = null;
        if(typeof this.props.tooltipTitle === "string" && xval) {
            retval = <div className="chartTooltip_title">{this.props.tooltipTitle}</div>    
        } else if(typeof this.props.tooltipTitle === "function" && xval) {
            retval = <div className="chartTooltip_title">{this.props.tooltipTitle(xval)}</div>
        }   
        return retval;
    }
    render() {
        return <div style={{position:"relative"}}>
            <div style={{width:"70%",display:"inline-block",verticalAlign:"middle"}}>
                <SizeGiver>
                    <MouseTracker>
                        <SVGChart {...this.props}>
                            <LineChartChart onHighlight={this.handleHighlight}/>
                        </SVGChart>
                        {this.state.tooltipVisible?(<HtmlTooltip tooltipwidth="600px">
                            {this.getTooltipTitle(this.state.tooltipdata[0].xval)}
                            {this.state.tooltipdata.map((obj,i) => 
                                <p key={"tooltipitem_"+i} style={{color:obj.color}}>
                                    {this.props.tooltipFormatter?
                                            this.props.tooltipFormatter(obj.name,obj.xval,obj.yval):obj.yval
                                    }
                                </p>)
                            }
                        </HtmlTooltip>):null}
                    </MouseTracker>
                </SizeGiver>
            </div>
            <div style={{width:"30%",display:"inline-block",verticalAlign:"middle"}}>
                <HtmlLegend data={this.props.data}/>
            </div>
            
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/js/components/charting/LineChart/LineChart.jsx